module.exports = __webpack_public_path__ + "img/right_icon2.90bcc115.png";